import { DiscoveryWallState, QueryOrigin } from '../../models';

/**
 * Generates a new discovery wall state so this bundle can be reused in multiple modules
 */
export function getInitialDiscoveryWallState(): DiscoveryWallState {
  return {
    clicksRecommendations: {
      results: [],
      numFound: 0,
      showTagging: null
    },
    queriesRecommendations: {
      results: [],
      numFound: 0,
      showTagging: null
    },
    sectionRecommendations: {
      results: [],
      showTagging: null
    },
    userRecommendations: {
      results: [],
      numFound: 0,
      showTagging: null
    },
    loading: false,
    origin: QueryOrigin.discoveryWall
  };
}
